import React, { useContext } from "react";
import themeContext from "../../../../context/theme/ThemeContext";
import { LIGHT_THEME_ICON_COLOR } from "../../../../constants/Constants";

const UnreportedIcon = (props) => {
  const { themeName, getThemeColor, getThemeColorForTab } = useContext(themeContext);
  return (
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width="13"
    //   height="14"
    //   viewBox="0 0 13 14"
    //   fill="none"
    // >
    //   <g clipPath="url(#clip0_7308_126790)">
    //     <path
    //       fillRule="evenodd"
    //       clipRule="evenodd"
    //       d="M1.2832 2.91984V11.2C1.2832 11.97 1.8607 12.6 2.56654 12.6H10.1567L8.87335 11.2H2.56654V4.31984L1.2832 2.91984ZM6.52639 4.2L5.24306 2.8H8.34154V4.2H6.52639ZM3.84987 5.71984V7H5.02335L3.84987 5.71984ZM9.09306 7L7.80972 5.6H10.2665V7H9.09306ZM11.5499 9.68016V4.781L8.45062 1.4H3.95972L3.0306 0.386413L2.67639 0H8.45062C8.7907 0 9.11795 0.147 9.35537 0.413L12.4546 3.794C12.6985 4.053 12.8332 4.41 12.8332 4.781V11.0802L12.6556 10.8864L11.5499 9.68016ZM6.30668 8.4H3.84987V9.8H7.59002L6.30668 8.4Z"
    //       fill={props.active ? "white" : "#585858"}
    //     />
    //     <path
    //       d="M1.2832 1.40039L11.5499 12.6004"
    //       stroke={props.active ? "white" : "#585858"}
    //       strokeWidth="2"
    //       strokeLinecap="square"
    //     />
    //   </g>
    //   <defs>
    //     <clipPath id="clip0_7308_126790">
    //       <rect
    //         width="12.8333"
    //         height="14"
    //         fill={props.active ? "white" : "#585858"}
    //       />
    //     </clipPath>
    //   </defs>
    // </svg>

    //   <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width="19"
    //   height="18"
    //   viewBox="0 0 19 18"
    //   fill="none"
    // >
    //   <path
    //     d="M11.461 3.75L15.0835 7.3725V14.25H4.5835V3.75H11.461ZM11.461 2.25H4.5835C3.7585 2.25 3.0835 2.925 3.0835 3.75V14.25C3.0835 15.075 3.7585 15.75 4.5835 15.75H15.0835C15.9085 15.75 16.5835 15.075 16.5835 14.25V7.3725C16.5835 6.975 16.426 6.5925 16.141 6.315L12.5185 2.6925C12.241 2.4075 11.8585 2.25 11.461 2.25ZM6.0835 11.25H13.5835V12.75H6.0835V11.25ZM6.0835 8.25H13.5835V9.75H6.0835V8.25ZM6.0835 5.25H11.3335V6.75H6.0835V5.25Z"
    //     fill={props.active?"white":"#585858"}
    //   />
    // </svg>

    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width="12"
    //   height="15"
    //   viewBox="0 0 12 15"
    //   fill="none"
    // >
    //   <path
    //     d="M5.19375 9.84375L6.77813 8.25937L8.3625 6.675L5.19375 9.84375ZM1.5 15C1.0875 15 0.734375 14.8531 0.440625 14.5594C0.146875 14.2656 0 13.9125 0 13.5V1.5C0 1.0875 0.146875 0.734375 0.440625 0.440625C0.734375 0.146875 1.0875 -8.9407e-08 1.5 -8.9407e-08H7.5L12 4.5V13.5C12 13.9125 11.8531 14.2656 11.5594 14.5594C11.2656 14.8531 10.9125 15 10.5 15H1.5ZM6.75 5.25V1.5H1.5V13.5H10.5V5.25H6.75Z"
    //     fill={themeName != "light"?props.active?"white":"#bfbfbf":getThemeColor("icon-color")}
    //   />
    // </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
    >
      <path
        d="M5.71508 0H9.14357V4.00163C9.14357 4.94853 9.91119 5.71615 10.8581 5.71615H14.8592V13.7117C14.8592 14.9743 13.8357 15.9978 12.5732 15.9978H8.76221C10.376 14.8598 11.4302 12.9812 11.4302 10.8564C11.4302 7.38444 8.61556 4.56983 5.14357 4.56983C4.54919 4.56983 3.97408 4.65232 3.42905 4.80648V2.28603C3.42905 1.02349 4.45254 0 5.71508 0Z"
        //fill="#1F1F1F"
        fill={getThemeColorForTab(props.active)}
      />
      <path
        d="M10.8581 4.57314H14.8554L10.2967 0H10.2866V4.00163C10.2866 4.31726 10.5425 4.57314 10.8581 4.57314Z"
        //fill="#1F1F1F"
        fill={getThemeColorForTab(props.active)}
      />
      <path
        d="M10.2871 10.8564C10.2871 13.6971 7.98429 16 5.14357 16C2.30286 16 0 13.6971 0 10.8564C0 8.01571 2.30286 5.71285 5.14357 5.71285C7.98429 5.71285 10.2871 8.01571 10.2871 10.8564ZM5.14357 7.99888C4.82794 7.99888 4.57207 8.25476 4.57207 8.57039V10.8564C4.57207 11.1721 4.82794 11.4279 5.14357 11.4279C5.45921 11.4279 5.71508 11.1721 5.71508 10.8564V8.57039C5.71508 8.25476 5.45921 7.99888 5.14357 7.99888ZM5.14357 13.8568C5.53812 13.8568 5.85796 13.537 5.85796 13.1425C5.85796 12.7479 5.53812 12.4281 5.14357 12.4281C4.74903 12.4281 4.42919 12.7479 4.42919 13.1425C4.42919 13.537 4.74903 13.8568 5.14357 13.8568Z"
        //fill="#1F1F1F"
        fill={getThemeColorForTab(props.active)}
      />
    </svg>
  );
};

export default UnreportedIcon;
